export const onboardingChargePoint = (gridConnectionId: number | string): any => ({
  '-1': {
    id: -1,
    name: 'Cargador1',
    key: null,
    verbose_name: 'A1',
    vendor: 'Algo',
    model: null,
    status: 'Online',
    capacity: 75000,
    output_current: 0,
    charger_efficiency: '0.95',
    voltage: 1,
    use_vi: false,
    is_single_phase: false,
    local_list_version: 0,
    free_pass: false,
    auto_start: false,
    vehicle_rfid: false,
    save_logs: false,
    fill_manual_fields: false,
    created: '2021-11-06T03:33:41.421434',
    updated: '2023-04-17T14:56:07.983115',
    grid_connection: gridConnectionId,
    vehicle_station: null,
    firmware: null,
    latest_heartbeat: 38280,
    latest_boot_notification: null,
    latest_status_notification: null,
    connectors: [
      {
        id: -1,
        charging_profiles: [
          {
            id: -1,
            charging_schedule: {
              charging_profile: -1,
              charging_schedule_periods: [
                {
                  id: -1148,
                  start_period: '00:00:00',
                  limit: '50000.0',
                  number_phases: 3,
                  created: '2023-03-31T11:00:09.780195',
                  updated: '2023-03-31T11:00:09.780217',
                  charging_schedule: -1,
                },
                {
                  id: -1147,
                  start_period: '13:00:00',
                  limit: '40000.0',
                  number_phases: 3,
                  created: '2023-03-31T11:00:09.780195',
                  updated: '2023-03-31T11:00:09.780217',
                  charging_schedule: -1,
                },
              ],
              duration: '1 00:00:00',
              start_schedule: '2019-01-01T00:00:00',
              charging_rate_unit: 'W',
              min_charging_rate: null,
              created: '2021-11-06T03:34:43.780876',
              updated: '2023-03-30T18:06:43.614761',
            },
            stack_level: 0,
            charging_profile_purpose: 'ChargePointMaxProfile',
            charging_profile_kind: 'Recurring',
            recurrency_kind: 'Daily',
            valid_from: null,
            valid_to: null,
            created: '2021-11-06T03:34:43.766901',
            updated: '2021-11-06T03:34:43.766912',
            sync_status: null,
            sync_task_id: 'ceda48f4-85e8-4c90-965b-b2f7ed9291b1',
            connector: -1,
            transaction: null,
          },
        ],
        latest_transaction: {
          id: 217,
          vehicle: null,
          user_start: null,
          user_stop: null,
          reservation_id: null,
          id_tag_start: 'EVXADMIN',
          id_tag_stop: null,
          meter_start: 54,
          meter_stop: null,
          timestamp_start: '2022-06-21T16:10:42',
          timestamp_stop: '2022-06-21T16:10:42',
          reason_stop: null,
          soc_start: null,
          soc_stop: null,
          cost: null,
          price: null,
          max_power: null,
          avg_power: null,
          total_energy: null,
          soh: null,
          odometer: null,
          remaining_time: null,
          created: '2022-06-21T16:12:29.812820',
          updated: '2022-06-21T16:12:29.812848',
          connector: 1,
        },
        latest_meter_value: null,
        latest_status_notification: null,
        connector_id: 0,
        availability: 'Operative',
        verbose_name: 'Input',
        plug_type: 'NoPlug',
        final_soc: 100,
        enabled: true,
        math_price: '210*total_energy/1000.0',
        created: '2021-11-06T03:34:43.763072',
        updated: '2021-11-06T03:34:43.763088',
        charge_point: -1,
      },
      {
        id: -2,
        charging_profiles: [
          {
            id: 2,
            charging_schedule: {
              charging_profile: 2,
              charging_schedule_periods: [],
              duration: '1 00:00:00',
              start_schedule: '2019-01-01T00:00:00',
              charging_rate_unit: 'A',
              min_charging_rate: null,
              created: '2021-11-06T03:35:03.230705',
              updated: '2023-03-20T12:46:40.752479',
            },
            stack_level: 1,
            charging_profile_purpose: 'TxDefaultProfile',
            charging_profile_kind: 'Recurring',
            recurrency_kind: 'Daily',
            valid_from: null,
            valid_to: null,
            created: '2021-11-06T03:35:03.229653',
            updated: '2021-11-06T03:35:03.229664',
            sync_status: null,
            sync_task_id: '3676ffea-f005-489b-b2ea-7949b31ac6f3',
            connector: 2,
            transaction: null,
          },
        ],
        latest_transaction: null,
        latest_meter_value: null,
        latest_status_notification: {
          id: 317031,
          error_code: 'NoError',
          info: null,
          status: 'Available',
          timestamp: '2023-03-27T15:51:11',
          vendor_id: null,
          vendor_error_code: null,
          verbose_error: 'Error not interpreted',
          created: '2023-03-27T15:52:10.150370',
          updated: '2023-03-27T15:52:10.150378',
          connector: 2,
        },
        connector_id: 1,
        availability: 'Operative',
        verbose_name: '1',
        plug_type: 'NoPlug',
        final_soc: 92,
        enabled: true,
        math_price: '210*total_energy/1000.0',
        created: '2021-11-06T03:35:03.228302',
        updated: '2023-01-09T18:03:28.202204',
        charge_point: -1,
      },
      {
        id: -3,
        charging_profiles: [
          {
            id: 3,
            charging_schedule: {
              charging_profile: 3,
              charging_schedule_periods: [],
              duration: '1 00:00:00',
              start_schedule: '2019-01-01T00:00:00',
              charging_rate_unit: 'W',
              min_charging_rate: null,
              created: '2021-11-06T03:35:10.890996',
              updated: '2023-03-20T12:55:45.710624',
            },
            stack_level: 2,
            charging_profile_purpose: 'TxDefaultProfile',
            charging_profile_kind: 'Recurring',
            recurrency_kind: 'Daily',
            valid_from: null,
            valid_to: null,
            created: '2021-11-06T03:35:10.889972',
            updated: '2021-11-06T03:35:10.889982',
            sync_status: null,
            sync_task_id: 'c59d8364-510f-426c-abc2-6fabbce5ac8a',
            connector: 3,
            transaction: null,
          },
        ],
        latest_transaction: {
          id: 214,
          vehicle: {
            number_plate: 'LWTK60',
            latest_transaction: {
              id: 214,
              reservation_id: null,
              id_tag_start: 'JHERNANDEZ',
              id_tag_stop: null,
              meter_start: 10,
              meter_stop: null,
              timestamp_start: '2022-06-08T20:54:37',
              timestamp_stop: '2022-06-08T20:54:37',
              reason_stop: null,
              soc_start: 50,
              soc_stop: null,
              cost: null,
              price: null,
              max_power: null,
              avg_power: null,
              total_energy: null,
              soh: null,
              odometer: null,
              remaining_time: null,
              connector: 3,
              user_start: null,
              user_stop: null,
              vehicle: 'LWTK60',
            },
            verbose_name: '786',
            vin: '9CF6DD9180D5',
            vin2: null,
            brand: 'King Long',
            model: 'XMQ 6127',
            class_type: 'Bus',
            nominal_range: 0,
            consumption: 0,
            battery_nominal_capacity: null,
            co2eqIC: 0,
            vin_as_id_tag: true,
            latest_soc: null,
            latest_odometer: null,
            latest_remaing_km: null,
            latest_temperature: null,
            status: 'Offline',
            fleet: 3,
            latest_tracker_log: null,
          },
          user_start: null,
          user_stop: null,
          reservation_id: null,
          id_tag_start: 'JHERNANDEZ',
          id_tag_stop: null,
          meter_start: 10,
          meter_stop: null,
          timestamp_start: '2022-06-08T20:54:37',
          timestamp_stop: '2022-06-08T20:54:37',
          reason_stop: null,
          soc_start: 50,
          soc_stop: null,
          cost: null,
          price: null,
          max_power: null,
          avg_power: null,
          total_energy: null,
          soh: null,
          odometer: null,
          remaining_time: null,
          created: '2022-06-08T20:54:58.506121',
          updated: '2022-06-08T20:54:58.506132',
          connector: 3,
        },
        latest_meter_value: {
          id: 1,
          sampled_values: [
            {
              id: 12483,
              connector: 3,
              timestamp: '2022-01-07T07:08:56',
              value: '100',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'SoC',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2022-01-07T07:08:58.740558',
              updated: '2022-01-07T07:08:58.740570',
              meter_value: 1,
            },
            {
              id: 2,
              connector: 3,
              timestamp: '2021-11-10T16:22:59',
              value: '50000',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'Power.Active.Import',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2021-11-10T16:23:50.007862',
              updated: '2021-11-10T16:23:50.007876',
              meter_value: 1,
            },
            {
              id: 1,
              connector: 3,
              timestamp: '2021-11-10T16:18:25',
              value: '50000',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'Power.Active.Import',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2021-11-10T16:18:24.290043',
              updated: '2021-11-10T16:18:24.290053',
              meter_value: 1,
            },
            {
              id: 4,
              connector: 3,
              timestamp: '2021-11-10T16:17:12',
              value: '500001',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'Power.Active.Import',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2021-11-10T17:04:30.293106',
              updated: '2021-11-10T17:04:30.293119',
              meter_value: 1,
            },
            {
              id: 12482,
              connector: 3,
              timestamp: '2021-11-10T16:17:12',
              value: '100',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'SoC',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2022-01-07T07:02:23.703565',
              updated: '2022-01-07T07:02:23.703579',
              meter_value: 1,
            },
            {
              id: 12481,
              connector: 3,
              timestamp: '2021-11-10T16:17:12',
              value: '100',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'SoC',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2022-01-07T07:01:29.836805',
              updated: '2022-01-07T07:01:29.836817',
              meter_value: 1,
            },
          ],
          timestamp: '2021-11-10T16:17:12',
          created: '2021-11-10T16:17:29.223776',
          updated: '2021-11-10T16:17:29.223792',
          connector: 3,
          transaction: null,
        },
        latest_status_notification: {
          id: 317812,
          error_code: 'NoError',
          info: null,
          status: 'Preparing',
          timestamp: '2023-04-17T14:56:21',
          vendor_id: null,
          vendor_error_code: null,
          verbose_error: 'Error not interpreted',
          created: '2023-04-17T14:56:34.111478',
          updated: '2023-04-17T14:56:34.111486',
          connector: 3,
        },
        connector_id: 2,
        availability: 'Operative',
        verbose_name: '2',
        plug_type: 'CHAdeMO',
        final_soc: 66,
        enabled: true,
        math_price: '210*total_energy/1000.0',
        created: '2021-11-06T03:35:10.888698',
        updated: '2023-01-05T16:47:41.956619',
        charge_point: -1,
      },
      {
        id: -4,
        charging_profiles: [
          {
            id: 4,
            charging_schedule: {
              charging_profile: 4,
              charging_schedule_periods: [],
              duration: '1 00:00:00',
              start_schedule: '2019-01-01T00:00:00',
              charging_rate_unit: 'W',
              min_charging_rate: null,
              created: '2021-11-06T03:35:20.625177',
              updated: '2022-02-10T14:56:56.137968',
            },
            stack_level: 3,
            charging_profile_purpose: 'TxDefaultProfile',
            charging_profile_kind: 'Recurring',
            recurrency_kind: 'Daily',
            valid_from: null,
            valid_to: null,
            created: '2021-11-06T03:35:20.624151',
            updated: '2021-11-06T03:35:20.624162',
            sync_status: null,
            sync_task_id: '31031af5-a8e6-4ca3-b492-8c482451797f',
            connector: 4,
            transaction: null,
          },
        ],
        latest_transaction: {
          id: 2,
          vehicle: {
            number_plate: '222222',
            latest_transaction: {
              id: 2,
              reservation_id: null,
              id_tag_start: 'bdiaz',
              id_tag_stop: null,
              meter_start: 0,
              meter_stop: null,
              timestamp_start: '2021-11-08T18:23:32',
              timestamp_stop: '2021-11-08T18:23:32',
              reason_stop: null,
              soc_start: 50,
              soc_stop: 81,
              cost: null,
              price: null,
              max_power: null,
              avg_power: null,
              total_energy: null,
              soh: null,
              odometer: null,
              remaining_time: null,
              connector: 4,
              user_start: null,
              user_stop: null,
              vehicle: '222222',
            },
            verbose_name: '222222',
            vin: null,
            vin2: null,
            brand: 'BusBrand',
            model: 'BusModel',
            class_type: 'Truck',
            nominal_range: 0,
            consumption: 0,
            battery_nominal_capacity: null,
            co2eqIC: 0,
            vin_as_id_tag: false,
            latest_soc: null,
            latest_odometer: null,
            latest_remaing_km: null,
            latest_temperature: null,
            status: 'Offline',
            fleet: 2,
            latest_tracker_log: 2,
          },
          user_start: null,
          user_stop: null,
          reservation_id: null,
          id_tag_start: 'bdiaz',
          id_tag_stop: null,
          meter_start: 0,
          meter_stop: null,
          timestamp_start: '2021-11-08T18:23:32',
          timestamp_stop: '2021-11-08T18:23:32',
          reason_stop: null,
          soc_start: 50,
          soc_stop: 81,
          cost: null,
          price: null,
          max_power: null,
          avg_power: null,
          total_energy: null,
          soh: null,
          odometer: null,
          remaining_time: null,
          created: '2021-11-08T18:23:54.300947',
          updated: '2022-05-05T21:38:07.203273',
          connector: 4,
        },
        latest_meter_value: {
          id: 2,
          sampled_values: [
            {
              id: 3,
              connector: 4,
              timestamp: '2021-11-10T17:03:09',
              value: '50001',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'Power.Active.Import',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2021-11-10T17:03:08.889423',
              updated: '2021-11-10T17:03:08.889435',
              meter_value: 2,
            },
            {
              id: 12486,
              connector: 4,
              timestamp: '2021-11-10T16:17:29',
              value: '81',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'SoC',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2022-01-07T22:06:18.269911',
              updated: '2022-01-07T22:06:18.269923',
              meter_value: 2,
            },
            {
              id: 12479,
              connector: 4,
              timestamp: '2021-11-10T16:17:29',
              value: '100',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'SoC',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2022-01-07T06:51:41.979771',
              updated: '2022-01-07T06:51:41.979783',
              meter_value: 2,
            },
            {
              id: 12480,
              connector: 4,
              timestamp: '2021-11-10T16:17:29',
              value: '100',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'SoC',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2022-01-07T06:52:11.327206',
              updated: '2022-01-07T06:52:11.327219',
              meter_value: 2,
            },
            {
              id: 12484,
              connector: 4,
              timestamp: '2021-11-10T16:17:29',
              value: '70',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'SoC',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2022-01-07T21:46:20.153755',
              updated: '2022-01-07T21:46:20.153778',
              meter_value: 2,
            },
            {
              id: 12485,
              connector: 4,
              timestamp: '2021-11-10T16:17:29',
              value: '100',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'SoC',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2022-01-07T22:03:56.715232',
              updated: '2022-01-07T22:03:56.715243',
              meter_value: 2,
            },
            {
              id: 12470,
              connector: 4,
              timestamp: '2021-11-10T16:17:29',
              value: '90',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'SoC',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2022-01-07T02:17:39.280617',
              updated: '2022-01-07T02:17:59.779787',
              meter_value: 2,
            },
            {
              id: 12471,
              connector: 4,
              timestamp: '2021-11-10T16:17:29',
              value: '100',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'SoC',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2022-01-07T02:18:22.794077',
              updated: '2022-01-07T02:18:22.794090',
              meter_value: 2,
            },
            {
              id: 12472,
              connector: 4,
              timestamp: '2021-11-10T16:17:29',
              value: '50',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'SoC',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2022-01-07T02:50:31.156167',
              updated: '2022-01-07T02:50:32.855706',
              meter_value: 2,
            },
            {
              id: 12473,
              connector: 4,
              timestamp: '2021-11-10T16:17:29',
              value: '100',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'SoC',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2022-01-07T03:21:20.297950',
              updated: '2022-01-07T03:21:20.297961',
              meter_value: 2,
            },
            {
              id: 12474,
              connector: 4,
              timestamp: '2021-11-10T16:17:29',
              value: '50',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'SoC',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2022-01-07T05:55:27.482162',
              updated: '2022-01-07T05:55:27.482174',
              meter_value: 2,
            },
            {
              id: 12475,
              connector: 4,
              timestamp: '2021-11-10T16:17:29',
              value: '100',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'SoC',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2022-01-07T06:14:08.440574',
              updated: '2022-01-07T06:14:08.440587',
              meter_value: 2,
            },
            {
              id: 12476,
              connector: 4,
              timestamp: '2021-11-10T16:17:29',
              value: '50',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'SoC',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2022-01-07T06:25:12.675546',
              updated: '2022-01-07T06:25:12.675559',
              meter_value: 2,
            },
            {
              id: 12477,
              connector: 4,
              timestamp: '2021-11-10T16:17:29',
              value: '100',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'SoC',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2022-01-07T06:25:56.130236',
              updated: '2022-01-07T06:25:56.130249',
              meter_value: 2,
            },
            {
              id: 12478,
              connector: 4,
              timestamp: '2021-11-10T16:17:29',
              value: '50',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'SoC',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2022-01-07T06:50:59.000491',
              updated: '2022-01-07T06:50:59.000502',
              meter_value: 2,
            },
            {
              id: 1649,
              connector: 4,
              timestamp: '2021-11-08T16:22:59',
              value: '50',
              context: 'Sample.Periodic',
              value_format: 'Raw',
              measurand: 'SoC',
              phase: null,
              location: 'Outlet',
              unit: 'Wh',
              created: '2021-12-13T00:19:23.576826',
              updated: '2021-12-13T00:19:23.576838',
              meter_value: 2,
            },
          ],
          timestamp: '2021-11-10T16:17:29',
          created: '2021-11-10T16:17:55.650392',
          updated: '2021-11-10T16:17:55.650403',
          connector: 4,
          transaction: 2,
        },
        latest_status_notification: {
          id: 317813,
          error_code: 'NoError',
          info: null,
          status: 'Charging',
          timestamp: '2023-04-17T14:56:34',
          vendor_id: null,
          vendor_error_code: null,
          verbose_error: 'Error not interpreted',
          created: '2023-04-17T14:56:51.226371',
          updated: '2023-04-17T14:56:51.226382',
          connector: 4,
        },
        connector_id: 3,
        availability: 'Operative',
        verbose_name: '3',
        plug_type: 'CHAdeMO',
        final_soc: 81,
        enabled: true,
        math_price: '210*total_energy/1000.0',
        created: '2021-11-06T03:35:20.622822',
        updated: '2022-05-06T15:12:07.879482',
        charge_point: -1,
      },
      {
        id: -5,
        charging_profiles: [
          {
            id: 5,
            charging_schedule: {
              charging_profile: 5,
              charging_schedule_periods: [],
              duration: '1 00:00:00',
              start_schedule: '2019-01-01T00:00:00',
              charging_rate_unit: 'W',
              min_charging_rate: null,
              created: '2021-11-06T03:35:28.520926',
              updated: '2021-11-06T03:35:28.520936',
            },
            stack_level: 4,
            charging_profile_purpose: 'TxDefaultProfile',
            charging_profile_kind: 'Recurring',
            recurrency_kind: 'Daily',
            valid_from: null,
            valid_to: null,
            created: '2021-11-06T03:35:28.519938',
            updated: '2021-11-06T03:35:28.519948',
            sync_status: null,
            sync_task_id: '0e9a9d6f-7177-418a-bfd3-b4d9e02987af',
            connector: 5,
            transaction: null,
          },
        ],
        latest_transaction: {
          id: 208,
          vehicle: {
            number_plate: 'LWTK44',
            latest_transaction: {
              id: 184,
              reservation_id: null,
              id_tag_start: '9CF6DD9180D4',
              id_tag_stop: '9CF6DD9180D4',
              meter_start: 104851992,
              meter_stop: 104851992,
              timestamp_start: '2022-02-07T17:48:00.005000',
              timestamp_stop: '2022-02-07T17:48:07.378000',
              reason_stop: 'Other',
              soc_start: 74,
              soc_stop: 74,
              cost: 0,
              price: 0,
              max_power: '0.00',
              avg_power: '0.00',
              total_energy: 0,
              soh: null,
              odometer: null,
              remaining_time: null,
              connector: 22,
              user_start: null,
              user_stop: null,
              vehicle: 'LWTK44',
            },
            verbose_name: '770',
            vin: '9CF6DD9180D4',
            vin2: null,
            brand: 'King Long',
            model: 'XMQ 6127',
            class_type: 'Bus',
            nominal_range: 0,
            consumption: 0,
            battery_nominal_capacity: null,
            co2eqIC: 0,
            vin_as_id_tag: true,
            latest_soc: null,
            latest_odometer: null,
            latest_remaing_km: null,
            latest_temperature: null,
            status: 'Offline',
            fleet: 3,
            latest_tracker_log: null,
          },
          user_start: null,
          user_stop: null,
          reservation_id: null,
          id_tag_start: 'JHERNANDEZ',
          id_tag_stop: 'JHERNANDEZ',
          meter_start: 0,
          meter_stop: null,
          timestamp_start: '2022-04-25T21:42:45',
          timestamp_stop: '2022-04-25T23:43:38',
          reason_stop: 'Other',
          soc_start: 66,
          soc_stop: 100,
          cost: 5420,
          price: 5950,
          max_power: null,
          avg_power: null,
          total_energy: 45,
          soh: null,
          odometer: null,
          remaining_time: null,
          created: '2022-04-25T23:44:03.021445',
          updated: '2022-05-05T21:38:07.222406',
          connector: 5,
        },
        latest_meter_value: null,
        latest_status_notification: {
          id: 317814,
          error_code: 'NoError',
          info: null,
          status: 'Finishing',
          timestamp: '2023-04-17T14:56:52',
          vendor_id: null,
          vendor_error_code: null,
          verbose_error: 'Error not interpreted',
          created: '2023-04-17T14:57:15.990777',
          updated: '2023-04-17T14:57:15.990789',
          connector: 5,
        },
        connector_id: 4,
        availability: 'Operative',
        verbose_name: '4',
        plug_type: 'GB/T DC',
        final_soc: 100,
        enabled: true,
        math_price: '210*total_energy/1000.0',
        created: '2021-11-06T03:35:28.518644',
        updated: '2023-01-09T18:03:48.974828',
        charge_point: -1,
      },
    ],
  },
});
